export default __webpack_public_path__ + "static/media/remove_answer.ba733aff.svg";